export var ReservedValueStoreKeys;
(function (ReservedValueStoreKeys) {
    /**
     * Application Instance Id (UUID)
     */
    ReservedValueStoreKeys["applicationInstanceId"] = "ApplicationInstanceId";
    /**
     * The stratus user id
     * 'stratus_id' in the stratus access token
     */
    ReservedValueStoreKeys["stratusUserId"] = "StratusUserId";
    /**
     * The hpid user id
     * 'sub' in the stratus access token
     */
    ReservedValueStoreKeys["hpIdUserId"] = "HpIdUserId";
    /**
     * The wpid user id
     * 'wpid' in the stratus access token
     */
    ReservedValueStoreKeys["wpIdUserId"] = "WpIdUserId";
    /**
     * The user's program level
     *
     * - TODO: Add more detail
     */
    ReservedValueStoreKeys["userProgramLevel"] = "UserProgramLevel";
    /**
     * The currently selected printer UUID
     */
    ReservedValueStoreKeys["selectedPrinterUuid"] = "SelectedPrinterUUID";
    /**
     * The model number of the selected printer
     * For example, the selected printer in the carousel for HP Smart
     */
    ReservedValueStoreKeys["selectedPrinterModelNumber"] = "SelectedPrinterModelNumber";
    /**
     * Application Identifier Name
     * Example: 'com.hpi.cdm.testapp'
     */
    ReservedValueStoreKeys["webApplicationName"] = "WebApplicationName";
    /**
     * Application version, 3 dot notation.
     * Semantic Versioning is HIGHLY recommended, with 4 segment for a monotonically increasing buildnumber or yyyymmddhh
     * Example: '8.4.1.2'
     */
    ReservedValueStoreKeys["webApplicationVersion"] = "WebApplicationVersion";
    /**
     * Contents of the OneTrust OptanonConsent cookie with a urn prefix (URL decoded!!)
     * urn model used to allow for migration away from OneTrust in the future
     */
    ReservedValueStoreKeys["webApplicationConsent"] = "WebApplicationConsent";
    /**
     * Unique UUID for the visit, intended as a short term cooking tracking (tbd app specific)
     * Example being a uuid set to a session cookie with an idle timeout of 1hr
     * Ex: "123e4567-e89b-12d3-a456-426614174000"
     */
    ReservedValueStoreKeys["visitUuid"] = "VisitUuid";
    /**
     * Unique UUID for the visitor, intended as a long term cookie tracking (tbd onetrust?)
     * Example being the consentId uuid value from webAppConsent field
     * Example: "123e4567-e89b-12d3-a456-426614174000"
     */
    ReservedValueStoreKeys["visitorUuid"] = "VisitorUuid";
    /**
     * Cloud service correlation linking key
     */
    ReservedValueStoreKeys["ucdeCorrelationId"] = "UcdeCorrelationId";
    /**
     * (Windows) The Device UUID (BIOS UUID) pulled from System APIs.
     */
    ReservedValueStoreKeys["pcDeviceUuid"] = "PcDeviceUuid";
    /**
     * The serial number that is pulled from System APIs.
     */
    ReservedValueStoreKeys["systemSerialNumber"] = "SystemSerialNumber";
    /**
     * The tenant id
     * The tenant ID to request a new user token be bounded to
    */
    ReservedValueStoreKeys["tenantId"] = "TenantId";
    /**
     * The consentBasis ID for the legal basis of consent obtained for data processing activities.
     */
    ReservedValueStoreKeys["consentBasisId"] = "ConsentBasisId";
    /**
     * Application Name
     */
    ReservedValueStoreKeys["applicationName"] = "ApplicationName";
})(ReservedValueStoreKeys || (ReservedValueStoreKeys = {}));
/**
 * The types of the possible errors returned when invoking the ValueStore Plugin.
 */
export var ValueStoreErrorType;
(function (ValueStoreErrorType) {
    /**
     * Invalid options were passed into the ValueStore plugin method.
     */
    ValueStoreErrorType["invalidOptions"] = "InvalidOptions";
    /**
     * Unknown error occurred while calling the ValueStore Plugin
     */
    ValueStoreErrorType["unknownError"] = "UnknownError";
})(ValueStoreErrorType || (ValueStoreErrorType = {}));
//# sourceMappingURL=valuestore.js.map